import { render, staticRenderFns } from "./detailManage.vue?vue&type=template&id=142200e4&scoped=true"
import script from "./detailManage.vue?vue&type=script&lang=ts"
export * from "./detailManage.vue?vue&type=script&lang=ts"
import style0 from "./detailManage.vue?vue&type=style&index=0&id=142200e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142200e4",
  null
  
)

export default component.exports